export default "__VITE_ASSET__Bs6Ukwx2__"